import { useState, useEffect } from 'react';
import { navLinks } from '@/mocks/zh/common';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 bg-accent-500 rounded-lg flex items-center justify-center">
              <i className="ri-fire-line text-lg text-background-50"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              51黑料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-600 hover:bg-background-100' : 'text-background-50/80 hover:bg-white/10'
            }`}>
              <i className="ri-search-line"></i>
            </button>
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-accent-500 text-foreground-950 hover:bg-accent-600'
                  : 'bg-accent-500 text-foreground-950 hover:bg-accent-400'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className="mt-2 px-5 py-3 text-sm font-semibold bg-accent-500 text-foreground-950 rounded-full text-center hover:bg-accent-600 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}